import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { mtFindPerson } from "../../api/mtFindPerson";
import { getRespuestaCuestionario } from "../../api/getRespuestaCuestionario";
import arrow_green from "../../assets/arrow_green.svg";
import Modal from 'react-bootstrap/Modal';
import "./stylePdf.css";

function Pantalla27() {

  const navigate = useNavigate();
  const isRunned = useRef(false);
  const [loading, setLoading] = useState(false);
  const [validateExperiencia, setValidateExperiencia] = useState(false);
  const [validateLic, setValidateLic] = useState(false);
  const [validateVial, setValidateVial] = useState(false);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState('');

  const handleClose = () => {
    setShow(false);
  }

  useEffect(() => {

    if (isRunned.current) return;
    setLoading(true);
    isRunned.current = true;

    async function createSession() {

      setLoading(true);
      localStorage.removeItem("interviewIdINE");
      localStorage.removeItem("tokenIncodeINE");
      localStorage.removeItem("typeOfId");
      localStorage.removeItem("vigenciaCpv");
      localStorage.removeItem("telefono");

      const objCons = {
        id: localStorage.getItem("idPerson"),
      };

      const response = await mtFindPerson(objCons);

      if (response.status === 200) {

        /** Validacion datos completos de licencia */

        if (response.datosLicenciaCompleto === true) {
          setValidateLic(true);
        }

        if (response.experienciaProfesionalRef === true) {
          setValidateExperiencia(true);
        }

        if (response.conocimientoVialRef === true) {
          setValidateVial(true);
        }

        if (
          response.datosLicenciaCompleto === true &&
          response.experienciaProfesionalRef === true &&
          response.conocimientoVialRef === true
        ) {

          const objRespuest = {
            id: localStorage.getItem("idPerson"),
            sCpv: response.cpv,
            sRespCon: response.objConocimiento,
            sResp: response.objExperiencia,
          };

          const dataPreguntas = await getRespuestaCuestionario(objRespuest);
          if (dataPreguntas.status !== 200) {
            setLoading(false);
            setShow(true);
            setShowStatus(dataPreguntas.status);
            setShowMessage(dataPreguntas.message);
          }
        }

        setLoading(false);

      } else {

        setLoading(false);
        setShow(true);
        setShowStatus(response.status);
        setShowMessage(response.message);

      }
      setLoading(false);
    }

    createSession();

  }, []);

  const getHomeLicConducir = async () => {
    navigate("/HomeLicConducir");
  };

  const getConocimientoVial = async () => {
    navigate("/HomeConocimientoVial");
  };

  const getHomeExpProfesional = async () => {
    navigate("/HomeExpProfesional");
  };

  return (
    <>
      {loading ? (
        <div className="containerRender">
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="containerInfo_P2">
          <div className="rcornersDes27">

            {/* Experiencia profesional */}

            {!validateExperiencia ? (
              <>
                <div className="itemAuto">
                  <div className="col-2 boxCheck">
                    <input type="radio" className="rdnSizeCheck" disabled />
                  </div>
                  <div className="col-8 centerText">
                    <span className="Experiencia-profesional">
                      Experiencia profesional
                    </span>
                  </div>
                  <div className="col-2 boxCheck">
                    <img
                      className="Rectangle-1408"
                      src={arrow_green}
                      onClick={getHomeExpProfesional}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div>
                  <div className="itemAuto">
                    <div className="col-2 boxCheck">
                      <input type="radio" className="rdnSizeCheck" checked />
                    </div>
                    <div className="col-8 centerText">
                      <span className="Experiencia-profesional">
                        Experiencia profesional
                      </span>
                    </div>
                    <div className="col-2 boxCheck" />
                  </div>
                </div>
              </>
            )}
            <hr className="hrItem" />

            {/* Conociemiento vial */}

            {!validateVial ? (
              <>
                <div>
                  <div className="itemAuto">
                    <div className="col-2 boxCheck">
                      <input
                        className="radioClassCheck"
                        type="radio"
                        disabled
                      />
                    </div>
                    <div className="col-8 centerText">
                      <span className="Conocimiento-vial">Conocimiento vial</span>
                    </div>
                    <div className="col-2 boxCheck">
                      <img
                        className="Rectangle-1408"
                        src={arrow_green}
                        onClick={getConocimientoVial}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div>
                  <div className="itemAuto">
                    <div className="col-2 boxCheck">
                      <input type="radio" className="rdnSizeCheck" checked />
                    </div>
                    <div className="col-8 centerText">
                      <span className="Conocimiento-vial">Conocimiento vial</span>
                    </div>
                    <div className="col-2 boxCheck" />
                  </div>
                </div>
              </>
            )}
            <hr className="hrItem" />

            {/* Licencia de Conducir */}

            {!validateLic ? (
              <>
                <div>
                  <div className="itemAuto">
                    <div className="col-2 boxCheck">
                      <input
                        className="radioClassCheck"
                        type="radio"
                        disabled
                      />
                    </div>
                    <div className="col-8 centerText">
                      <span className="Licencia-de-conducir">
                        Licencia de conducir
                      </span>
                    </div>
                    <div className="col-2 boxCheck">
                      <img
                        className="Rectangle-1408"
                        src={arrow_green}
                        onClick={getHomeLicConducir}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div>
                  <div className="itemAuto">
                    <div className="col-2 boxCheck">
                      <input type="radio" className="rdnSizeCheck" checked />
                    </div>
                    <div className="col-8 centerText">
                      <span className="Licencia-de-conducir">
                        Licencia de conducir
                      </span>
                    </div>
                    <div className="col-2 boxCheck" />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className='backGroudModal'>
          <div className='msjTitleModalDiv'>Error {showStatus}</div>
          <div className='msjErrorModal'>{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='button_P2' onClick={handleClose}>
            <span className='txtButton_P2'>Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>

    </>
  );
}

export default Pantalla27;
